import React, { useState, useRef } from 'react'
import { useGame } from '../contexts/GameContext'

export const SimpleFallback: React.FC = () => {
  const { gameState, incrementScore, startGame, endGame } = useGame()
  const [ballPosition, setBallPosition] = useState({ x: 50, y: 80 })
  const [isAnimating, setIsAnimating] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const handleSwipe = (_e: React.TouchEvent | React.MouseEvent) => {
    if (isAnimating) return

    if (!gameState.gameStarted) {
      startGame()
    }

    setIsAnimating(true)

    // Simple ball animation
    const targetX = Math.random() * 60 + 20 // Random position
    const targetY = 20 // Crossbar height

    setBallPosition({ x: targetX, y: targetY })

    setTimeout(() => {
      // Check if hit the crossbar area
      if (targetX >= 45 && targetX <= 55 && targetY <= 25) {
        incrementScore()
        setBallPosition({ x: 50, y: 80 }) // Return ball
        setIsAnimating(false)
      } else {
        // Miss - game ends
        setTimeout(() => {
          endGame()
          setIsAnimating(false)
        }, 500)
      }
    }, 1000)
  }

  return (
    <div className="w-full h-full bg-gradient-to-b from-blue-300 to-green-300 relative overflow-hidden">
      {/* DEBUG: Показываем текст для проверки рендера на мобильном */}
      <div style={{color: 'red', fontWeight: 'bold', fontSize: 24, position: 'absolute', top: 10, left: 10, zIndex: 9999}}>
        DEBUG: SimpleFallback mounted
      </div>
      {/* Score counter */}
      <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-4 py-2 rounded-lg text-xl font-bold">
        Score: {gameState.score}
      </div>

      {/* Game field */}
      <div
        ref={containerRef}
        className="w-full h-full relative cursor-pointer"
        onTouchStart={handleSwipe}
        onClick={handleSwipe}
      >
        {/* Ground */}
        <div className="absolute bottom-0 w-full h-1/4 bg-green-600"></div>

        {/* Goal */}
        <div className="absolute bottom-1/4 left-1/2 transform -translate-x-1/2">
          {/* Goal posts */}
          <div className="w-2 h-20 bg-white absolute left-0 bottom-0"></div>
          <div className="w-2 h-20 bg-white absolute right-0 bottom-0"></div>
          {/* Crossbar */}
          <div className="w-20 h-2 bg-yellow-400 absolute top-0 left-0"></div>
        </div>

        {/* Ball */}
        <div
          className={`w-6 h-6 bg-red-500 rounded-full absolute transition-all duration-1000 ${isAnimating ? 'ease-out' : ''}`}
          style={{
            left: `${ballPosition.x}%`,
            bottom: `${ballPosition.y}%`,
            transform: 'translate(-50%, 50%)'
          }}
        ></div>

        {/* Start screen */}
        {!gameState.gameStarted && !gameState.isGameOver && (
          <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 pointer-events-none">
            <div className="bg-white p-6 rounded-lg text-center pointer-events-auto">
              <h1 className="text-2xl font-bold mb-4">Crossbar Challenge</h1>
              <p className="text-sm mb-4">2D mode (WebGL unavailable)</p>
              <p className="text-sm">Touch the screen to start</p>
            </div>
          </div>
        )}

        {/* Instructions */}
        {gameState.gameStarted && !gameState.isGameOver && (
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-4 py-2 rounded text-sm">
            Touch to hit the ball towards the crossbar
          </div>
        )}
      </div>
    </div>
  )
}
